import { PersonInfo } from '../../model/PersonInfo';
import { DoctorInfoDtoIn, PatientInfoDtoIn } from '../../generated';

export const fromPersonToGenerated = (data: PersonInfo): PatientInfoDtoIn | DoctorInfoDtoIn => {
  return {
    titleBefore: data.titleBefore,
    titleAfter: data.titleAfter,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    note: data.note
  };
};
